module.exports = __webpack_public_path__ + "static/media/6010752-uhd_3840_2160_25fps.bf116d20.mp4";